import gql from 'graphql-tag';
import { getCounterpartyId } from '../../../services/authService';

export const getMyClientsQuery = gql`
	{
  allBnyClients(tenantId: "${getCounterpartyId()}") {
    id
    tenantId
    clientId
    shortCode
    shortName
    longName
    groupId
    }
  }
`;
